import { useRouterAdapter } from './context'

export { RouterAdapterProvider, useRouterAdapter } from './context'
export type { RouterAdapter, AppNavigateFn, AppNavigateOptions, AppLocation } from './types'

export function useAppNavigate() {
  const { useNavigate } = useRouterAdapter()
  return useNavigate()
}

export function useAppParams<T extends Record<string, string | undefined> = Record<string, string | undefined>>() {
  const { useParams } = useRouterAdapter()
  return useParams<T>()
}

export function useAppLocation() {
  const { useLocation } = useRouterAdapter()
  return useLocation()
}

export function useAppSearchParams() {
  const { useSearchParams } = useRouterAdapter()
  return useSearchParams()
}

export { createReactRouterAdapter } from './adapters/react-router'
export { createTanStackAdapter } from './adapters/tanstack'
